module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-no",
    attrs: {
      "id": "chap01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch1.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("I Am Interesting")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Lesson 1: Paying Attention")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcapl"
  }, [_vm._v("B")]), _vm._v("eing asked what interests us is a fundamental and go-to question many people resort to when first getting to know someone. On a materialistic level, this question is likely extremely easy for almost everyone to answer. It could be any sport, hobby, or craft. We all have things of interest we devote our free time to. However, what if we switched the wording of the question “What are your interests?” to “What makes you interesting?” Chances are, that second question is much more difficult or even uncomfortable to answer. But why? The truth “I am interesting” is necessary to have as a foundation to building one of the things God is interested in most: relationships. Most of us don’t walk around saying how interesting we are, but the belief of this truth impacts both the way we view ourselves and how we view others dramatically.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thinking about my own life, the struggle to believe this truth began at an early age. Most of the people who met me after high school would have a hard time believing this, but I was by far one of the quietest kids in my class for all of my childhood. I grew up with the mindset that, the more people knew about me, the more evidence they had to form false perceptions or stereotypes about me. My fear was largely the result of an insecurity about my own identity. I wanted close relationships with people, but I wasn’t confident enough to share my personal story with them to get there. I knew I was more than a stereotype, and if people were actually interested in getting to know me further, they would have learned that too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How do we believe the truth “I am interesting?”")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Interest")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("noun")]), _vm._v(" curiosity, concern; "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("verb")]), _vm._v(" to engage the attention of"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn1",
      "id": "fn_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How do we engage the attention of something? One of the avenues leading to the belief of feeling interesting is through the belief that we can engage the attention of people, or that they want to pay their attention toward us. What makes arriving at this belief so hard?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To address this, we look to the fact that the phrase “paying attention” specifically includes the word "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("paying")]), _vm._v(" in it. This indicates that in order for someone to focus their attention on or toward us, it "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("costs")]), _vm._v(" them something. In my case, the cost was spending the time with me and them getting to know my true self.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Regardless of the cost’s nature, when we struggle to see our worth, chances are we also struggle to see how someone else could want to pay their attention toward us.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("What do you find yourself paying attention to?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("Can you think of any instances where you felt unworthy of someone’s attention?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The truth is, God sees each of us as being worth the cost of his son’s life. He is extremely interested in our well-being and desires each of us to pay attention to the things he has for us. What exactly should our attention be placed in?")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("God’s Word")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("“Pay attention to all that I have said to you, and make no mention of the names of other gods, nor let it be heard on your lips.” Exodus 23:13 ESV")])]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("God’s Commands")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("The LORD will make you the head, not the tail. If you pay attention to the commands of the LORD your God that I give you this day and carefully follow them, you will always be at the top, never at the bottom. Deuteronomy 28:13 NIV")])]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("The Hearts of Others")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("But the LORD said to him, “Pay no attention to how tall and handsome he is. I have rejected him, because I do not judge as people judge. They look at the outward appearance, but I look at the heart.” 1 Samuel 16:7")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As these verses suggest, our attention is to be put in things which cannot be seen by the human eye. Placing our attention in things unseen requires a greater level of interest and investment. Wherever our interests lie, our attention lies also. Our attention holds extreme value. The enemy also recognizes the value of our attention, so much so, that he tries to steal our attention constantly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("How often do you find yourself becoming distracted from the things you should pay attention to? What draws your attention away during those times?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We don’t pay attention to things because we have to, but because we made the choice to. Having a physical presence and actually paying attention are vastly different.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we successfully identify that people pay attention to us because they take interest in what we’re saying or doing, believing the truth of “I am interesting” becomes much easier.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("How can you be more intentional in the ways you pay attention to others so that they know you show interest in them?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("Do you ever struggle to feel that God is paying attention to you? If so, why?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("How might you be able to pray into that situation and ask God to show you the attention he has for you?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "curve"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/curve.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Lesson 2: Curiosity")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since the dawn of our creation, curiosity has been a part of human nature. Dating back to the first sin committed by Eve in the garden, Satan fed into Eve’s curiosity of the forbidden fruit and enticed her to take the bite. Just as Eve had a curiosity about the forbidden fruit, we each have different subjects of curiosity. Our curiosities lead to either good or sinful results dependent upon how we act on them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having five older siblings, I was always curious to know what their lives were like. Often times when they entertained my company, it included sports and video games. Let me tell you, no other elementary school-aged girl at that time knew more about basketball in the Michael Jordan era than I did. I got pretty good at playing basketball on video games too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our curiosity leads to a variety of both good and bad outcomes. Eve’s curiosity was one of the variables that led to the first committed sin, but Isaac Newton also discovered gravity due to his curiosity of seeing an apple fall from a tree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In another definition of “interest” we see the word “curiosity.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn2",
      "id": "fn_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" How does this concept of curiosity connect to where we place our interests?")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Curious")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("adjective")]), _vm._v(" having a desire to investigate and learn"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn3",
      "id": "fn_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When anyone possesses a desire to learn or know more about us, it’s because we’ve piqued a curiosity in them. They are "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("interested")]), _vm._v(" in us. This concept of piquing the curiosity of others was a contributing factor of my inability to see the truth that I am an interesting person. I often thought to myself, “Someone couldn’t actually be curious enough about the little they knew about me to want to learn more, right?” There is no definite truth in that statement, but that’s exactly what the enemy wanted me to believe, and I did. Believing this, I shielded others away from being able to get to know more about me. For the entirety of my childhood, shielding people away didn’t seem like a big deal. I didn’t need to have the skill of opening up to people because God blessed me with many great friends very early on in life. I kept the same five closest friends I had in first grade all the way through graduating high school. Aside from those friends, I prevented myself from forming newer potentially great and sustaining relationships.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When on the level of others wanting to get to know more about us, this concept of curiosity is somewhat easy to grasp. But, what if we instead internalize the focus and look at curiosity in the sense of us wanting to get to know ourselves better? Is it possible for someone to know us better than we know ourselves?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("Have you ever had the desire to learn or know more about yourself? Why or why not?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is someone who knows more about us than we know about ourselves, and that “someone” is God. He holds the ability to teach us about ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "titalic"
  }, [_vm._v("Your knowledge of me is too deep; it is beyond my understanding. Psalm 139:6")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("Have you ever asked God to teach you more about yourself? If so, when was the last time and what did that look like? If not, what are you curious to learn about yourself?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At its root, our curiosity stems from a desire of some kind. In the Bible, we see two different types of desires. The desires of mankind and the desires of God. Ideally, our desires align with God’s, but that’s not always the case. How do we distinguish between the two? The Bible says that human desires:")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Give way to sin")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("But we are tempted when we are drawn away and trapped by our own evil desires. Then our evil desires conceive and give birth to sin; and sin, when it is full-grown, gives birth to death. James 1:14-15")])]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Perpetuate ignorance")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Therefore, with minds that are alert and fully sober, set your hope on the grace to be brought to you when Jesus Christ is revealed at his coming. As obedient children, do not conform to the evil desires you had when you lived in ignorance. But just as he who called you is holy, so be holy in all you do; 1 Peter 1:13-15 NIV")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Those verses bring us back to the first sin committed by Eve. The serpent in the garden tapped into Eve’s curiosity of the forbidden fruit. Through her human desire of wanting to learn more about the knowledge of good and evil, she ate the fruit, committed the first sin, and the separation of God and mankind took place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("God’s desires, unlike our own, are always free of unhealthy intentions. Another term used in the Bible when talking about the desires God has for us is “God’s will.” God has a will for each of us, what does his will consist of?")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "titalic"
  }, [_vm._v("For this is the will of God, that by doing good you should put to silence the ignorance of foolish people. Live as people who are free, not using your freedom as a cover-up for evil, but living as servants of God. 1 Peter 2:15-16 ESV")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Simply put, God wants us to live in freedom. In order to do so, we must devote our lives to him and have a relationship with him. If we don’t, we are subject to become weighed down by the slavery to our own sin.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("Do you have a hard time aligning your desires to God’s will for your life? What gets in the way for you to live a life of freedom?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("What steps can you take to align your desires to God’s will for your life to achieve freedom?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "curve"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/curve.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Lesson 3: Concern")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If someone were to come to us and say they were concerned about us, many of us would likely go into a defensive mode. If we didn’t know what they were referring to, we may even get concerned about them. Most often when we hear the word concern, we associate a negative connotation with it. Rightfully so, since one of the synonyms for “concern” is “worry.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn4",
      "id": "fn_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" But, for the purpose of this chapter, we are going to shift that focus. Worrying is "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("not")]), _vm._v(" a characteristic of God. Instead, we will focus on the other aspect of the word, which is:")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Concern")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("verb")]), _vm._v(" to relate to: be about"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn5",
      "id": "fn_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("What things do you show concern for because of your close relation or connection to them?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When it came to developing relationships in my childhood, concern was often the point where I stopped allowing people to enter my life. Externally, there was little evidence of anyone needing to be concerned for me. I had good grades, loving parents, and a group of a few good friends I was inseparable from. My house was the place to be after school. We had a swing set, trampoline, basketball hoop, and always had the best snacks to choose from.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To show the part of my life worthy of concern, I would need to open up about who I was internally. Because I seldom told people about my inner self, I gave them little to relate or connect with on a deeper level. Did people actually not want to relate with me? Of course not. It was my own assumption that someone would not be interested in getting to know me. Very little concern was necessary to be shown in making the friends I had growing up. All of them either lived in my neighborhood or had the same teachers in school, and they were the ones who asked me to be friends, not vice versa.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The truth is, there are a lot of people in this world interested in getting to know each one of us. When someone has an interest in us, showing concern for us comes as a result. Showing concern to others is of so much importance, that the Bible calls everyone in the body of Christ to show concern for one another.")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "titalic"
  }, [_vm._v("…so that there should be no division in the body, but that its parts should have equal concern for each other. If one part suffers, every part suffers with it; if one part is honored, every part rejoices with it. 1 Corinthians 12:25-26 NIV")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Community is God’s design. When we relate to and connect with other people, those people will develop a concern for us over time. They become "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("interested")]), _vm._v(" in us. If we don’t do our part in communicating who we really are to one another, we leave them nothing to connect with or take interest in. Chances are, most of us have more people who want to connect with us in our lives than we are aware of.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In order to recognize when others show concern for us, we must know what it looks like to show concern. What tools can we use to display a concern for one another?")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Communicate their value")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Therefore if you have any encouragement from being united with Christ, if any comfort from his love, if any common sharing in the Spirit, if any tenderness and compassion, then make my joy complete by being like-minded, having the same love, being one in spirit and of one mind. Do nothing out of selfish ambition or vain conceit. Rather, in humility value others above yourselves, not looking to your own interests but each of you to the interests of the others. Philippians 2:1-4 NIV")])]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Show justice")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("The righteous care about justice for the poor, but the wicked have no such concern. Proverbs 29:7 NIV")])]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Share Jesus’s interests")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("I hope in the Lord Jesus to send Timothy to you soon, that I also may be cheered when I receive news about you. I have no one else like him, who will show genuine concern for your welfare. For everyone looks out for their own interests, not those of Jesus Christ. Philippians 2:19-21 NIV")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("How can you become more like these verses and show value, justice, or interest to those around you?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("How have other people done those things for you?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Odds are, anyone who was behind those actions in the answer to the previous question finds interest in us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We must be able to identify ways we relate and connect with other people as well as recognize the ways people build us up. Once both of those things happen, relationships we begin to form with others will develop a greater level of authenticity. Feeling uninteresting can be conquered when we experience authenticity in relationships. If the concept of relating to other people sounds daunting, start with relating to God. He desires nothing more than to have a relationship with everyone, and will never grow disinterested in pursing that relationship.")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "titalic"
  }, [_vm._v("But God demonstrates his own love for us in this: While we were still sinners, Christ died for us. Romans 5:8 NIV")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("God’s concern for having a relationship with us is so great, his only son Jesus died for our salvation even during the midst of our sin. Nothing can ever take away God’s interest in us—all we have to do is invite him into our lives.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("What areas do you find yourself struggling to relate with others?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("How can you invite God into those areas and allow him to show you how he finds interest in you?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "curve"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/curve.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Lesson 4: Involvement")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would first like for us all to take a moment and think about the last time we sat in church and heard our pastor say, “We don’t know what to with all of the people wanting to get involved.” The answer to that question for almost every one of us is likely “Never.” There is no shortage of work to be done in the church:")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "titalic"
  }, [_vm._v("Then he said to his disciples, “The harvest is plentiful, but the laborers are few; therefore pray earnestly to the Lord of the harvest to send out laborers into his harvest.” Matthew 9:37-38 ESV")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ideally, the activities we choose to be involved in are a product of where our interests lie. Part of believing the truth “I am interesting” means believing our interests have merit. A good portion of my involvement all throughout my childhood included the involvement around sharing in other people’s interests rather than my own. I didn’t always do this out of the bottom of my heart as a good friend, but rather to avoid the potential disappointment I would have felt if they didn’t want to be involved with activities that surrounded my interests. Let’s be honest, I spent another good portion of my time as a kid at home practicing flash cards and playing math-based computer games. Who would want to know about the latest problem I learned how to solve?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We frequently put the interests God has given us on the back-burner because we fail to see the use or benefit of them. Other times, we simply disregard our interests because we’ve already invested too much time elsewhere. On the surface, having investments in many areas is not always a bad thing, but it has the potential to become one when we neglect the calling God has for each of our lives because don’t have the time to live out our calling.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("What are some of the people, places, or organizations with which you are currently involved?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("Why did you choose to be involved with each of them, and how is God glorified in them?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just as the church needs involvement from its members to succeed, we need people to be involved in our lives. When Jesus refers to the “harvest” in the passage from Matthew, he is referring to "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("us.")]), _vm._v(" People.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anytime we become involved in something, it requires some level of commitment from us. Commitment takes on multiple different forms. As followers of Christ, we must be committed to putting in the work required to cultivate the plentiful harvest that awaits. Our commitment comes in these forms:")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Work")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Commit your work to the LORD, and your plans will be established. Proverbs 16:3 ESV")])]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Trust")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("Trust in the LORD with all your heart and lean not on your own understanding; in all your ways submit to him, and he will make your paths straight. Proverbs 3:5-6 NIV")])]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Faith")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("By faith Abraham, when called to go to a place he would later receive as his inheritance, obeyed and went, even though he did not know where he was going. By faith he made his home in the promised land like a stranger in a foreign country; he lived in tents, as did Isaac and Jacob, who were heirs with him of the same promise. For he was looking forward to the city with foundations, whose architect and builder is God. Hebrews 11:8-10 NIV")])]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Finances")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("“For where your treasure is, there your heart will be also.” Matthew 6:21 ESV")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("What do these verses indicate as being some of the results of placing our commitment to God?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("What stops you from further committing or involving yourself with God?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("Think back to times in your life where people were committed to you or engaged in you in some way. Who were they and what did they do?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chances are, the people listed in the above questions find interest in us. To cultivate healthy relationships, we must be willing to both be involved in people’s lives and receive the involvement of other people into our life. Not doing so could unintentionally communicate to the other person that we are disinterested in them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("How can you display commitment to your everyday relationships, so that those close to you see your interest in them?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "curve"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/curve.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Lesson 5: Boredom")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Have you ever had someone tell you they find watching paint dry to be an interesting activity? I would bet that none of us have, as the phrase “it’s like watching paint dry” is used as a metaphor to represent boredom. The word “boring” is an antonym to the word “interesting.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn6",
      "id": "fn_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Meaning, if we have a hard time believing the truth “I am interesting,” chances are we also struggle with believing the truth “I am not boring.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These two truths sound drastically different. One tells us something that we "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("are")]), _vm._v(" and the other tells us something that we "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("aren’t")]), _vm._v(", but at their core, they are the same. Leading into this last lesson of the “I am interesting” chapter. What does boredom look like?")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Boredom")]), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("noun")]), _vm._v(" the condition of being weary and restless because of dullness"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn7",
      "id": "fn_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Upon researching the topic for this lesson, I found no references on where the Bible describes a person to be dull or boring. God created each and every one of us as reflections of him. If he isn’t boring, he didn’t create us as boring either.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, I did find instances in the Bible where it describes people as "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("becoming")]), _vm._v(" dull. Indicating, this “dullness” isn’t a characteristic of the people themselves, but rather a "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("product")]), _vm._v(" of the choices or actions they made. What does dullness look like?")]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('span', {
    staticClass: "titalic"
  }, [_vm._v("About this we have much to say, and it is hard to explain, since you have become dull of hearing. For though by this time you ought to be teachers, you need someone to teach you again the basic principles of the oracles of God. You need milk, not solid food, for everyone who lives on milk is unskilled in the word of righteousness, since he is a child. But solid food is for the mature, for those who have their powers of discernment trained by constant practice to distinguish good from evil. Hebrews 5:11-14 ESV")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("Can you think of a time where you were dull of hearing? What was the result of that situation?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("Can you think of a time where you exhibited discernment? What was the result of that situation?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Those verses point out that they were dull to hearing, or in other words, they were "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("uninterested")]), _vm._v(" in hearing. The people being addressed were intended to be something more or greater than their current state. They were intended to be teachers, but because of their lack of hearing, they instead needed to be taught.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The good news is, every single one of us has been given a power of discernment. The choice lies with us to receive and exercise powers of discernment or not. Dullness is a "), _c('span', {
    staticClass: "titalic"
  }, [_vm._v("choice")]), _vm._v("—not something we have to carry around with us. If we use our powers of discernment, we gain the maturity necessary to handle greater things than those who do not choose to exercise them. The lack of exercise in those powers leads to the dullness of hearing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That same concept can be applied when evaluating our relationships with others—we allow our perception of boredom to limit our greatness. For much of my childhood, I shied away from approaching people because I didn’t see how anyone would be interested in getting to know me. For that reason, one of my best friendships was made as a result of her approaching me. I stood at the edge of the playground away from the traffic of people one recess during elementary school, when a girl came up and asked me if I wanted to play with her. I tended to keep quiet and to myself during school, unwilling to risk the hurt of someone not wanting to get to know me. However, when she broke that initial barrier for me, I said “yes” and gained a great life-long friend as a result.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although that interaction had a profound impact on my life, I felt in general that I did people a favor by relieving them of potential boredom from having to listen to what I had to say. Discerning this concept on a deeper level, believing someone won’t want to hear what I have to say contains an unfair assumption about the other person. How can I know others’ true interest in me before even attempting to form a relationship with them? I can’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We can each rest assured that we were each created by a God who is mindful of details. God never grows bored of hearing from us, and if we ever find ourselves becoming dull of hearing, we can lay those feelings down at the cross. Dullness is not something we have to own. God is extremely interested in every single one of us.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-top"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("What are some things that lead you to feeling like you’re a dull or boring person?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "tbold"
  }, [_vm._v("How might we open our ears to use our powers of discernment to help both ourselves and others overcome this lie that we are boring?")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "curve"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/curve.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "blkct"
  }, [_vm._v("Dear God,")]), _vm._v(" "), _c('p', {
    staticClass: "blkc"
  }, [_vm._v("I ask that you would reveal to me the areas in my life in which I should be paying both more and less attention to. Help me to show an interest in others in the same way that you show interest in me. Teach me something new about myself that will help me to see how my human desires lead to sin. Replace those desires with a hunger to know more about your will for my life. I confess that most of the time I am more concerned about myself than I am other people, and that I don’t do enough to recognize and acknowledge other people’s concern for me. Supply me with the strength to be more committed to you in my actions, trust, faith, finances, and relationships. Open my ears to hear all of the ways in which you find me interesting, so that I may also combat the lie that I am boring.")]), _vm._v(" "), _c('p', {
    staticClass: "blkc"
  }, [_vm._v("In Jesus’ name,")]), _vm._v(" "), _c('p', {
    staticClass: "blkcn"
  }, [_vm._v("Amen.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36c29b33","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chap01.vue
// module id = 81
// module chunks = 0